/*
  TimelessXI: fills the product page colorway row (snippets/txi-colorways.liquid) with in-stock sibling products
  that share the brand and model name, fetched from store search (sections/txi-colorways.liquid).
  Hovering or focusing a swatch shows its colorway name, like Kith.
*/
if (!customElements.get('txi-colorways')) {
  customElements.define(
    'txi-colorways',
    class TxiColorways extends HTMLElement {
      static MAX_ITEMS = 12;

      connectedCallback() {
        this.list = this.querySelector('.txi-colorways__list');
        this.name = this.querySelector('.txi-colorways__name');
        this.currentName = this.name?.textContent || '';
        this.list.addEventListener('mouseover', (event) => this.preview(event));
        this.list.addEventListener('focusin', (event) => this.preview(event));
        this.list.addEventListener('mouseleave', () => this.restore());
        this.list.addEventListener('focusout', () => this.restore());
        this.load();
      }

      preview(event) {
        const item = event.target.closest('.txi-colorways__item');
        if (item && this.name) this.name.textContent = item.dataset.name;
      }

      restore() {
        if (this.name) this.name.textContent = this.currentName;
      }

      load() {
        fetch(this.dataset.url)
          .then((response) => (response.ok ? response.text() : ''))
          .then((text) => {
            if (!text) return;
            const html = new DOMParser().parseFromString(text, 'text/html');
            const seen = new Set([this.dataset.handle]);
            const items = [...html.querySelectorAll('.txi-colorways__item')].filter((item) => {
              if (item.dataset.key !== this.dataset.key || seen.has(item.dataset.handle)) return false;
              seen.add(item.dataset.handle);
              return true;
            });
            items.slice(0, TxiColorways.MAX_ITEMS - 1).forEach((item) => this.list.appendChild(document.importNode(item, true)));
            if (items.length) this.classList.add('has-siblings');
          })
          .catch(() => {});
      }
    }
  );
}
